const COLOR_DIVIDER_A = '#E9E9E9'
const COLOR_DIVIDER_C = '#B4B4B4'
const COLOR_A = '#090909' // '#444444'
const COLOR_A_A = '#161616'
const COLOR_B = '#454545'
const COLOR_B_A = '#E6E6E6'
const COLOR_C = '#897451'
const COLOR_C_A = '#B9A680'
const COLOR_C_B = '#AA8C61'
const COLOR_D = '#424242'
const COLOR_D_A = '#6D6D6D'
const COLOR_D_B = '#191919'
const COLOR_E = '#FFCD59'
const COLOR_E_A = '#FFCD7D'
const COLOR_E_B = '#FFDC7D'
const COLOR_F = '#fff'

const colors = {
  global: {
    colorTextSelectionBg: { key: 'color-text-selection-bg', value: COLOR_E_A },
    colorTextSelection: { key: 'color-text-selection', value: COLOR_F },
    colorTapHighlight: { key: 'color-tap-highlight', value: '#FFE6D650' },
    colorFocus: { key: 'color-focus', value: '#FFE6D650' },
    colorSiteFrame: { key: 'color-site-frame', value: '#FFF' },
    colorSiteBorder: { key: 'color-site-border', value: '#FFF' },
    colorSiteScrollbar: { key: 'color-site-scrollbar', value: '#000' },
    colorSiteScrollbarHover: {
      key: 'color-site-scrollbar-hover',
      value: '#ccc'
    },
    colorShadowA: { key: 'color-shadow-a', value: '#70706E' },
    colorShadowB: { key: 'color-shadow-b', value: '#757575' },
    colorShadowC: { key: 'color-shadow-c', value: '#1D1D1D' }
  },

  navigation: {
    colorNavBurger: { key: 'color-nav-burger', value: '#000' },
    colorNavBurgerHover: { key: 'color-nav-burger-hover', value: '#513d1f' },
    colorNavBurgerPress: { key: 'color-nav-burger-press', value: COLOR_D_A },
    colorNavItem: { key: 'color-nav-item', value: COLOR_A }
  },

  'burger-navigation': {
    colorBurgerNav: { key: 'color-burger-nav', value: COLOR_A_A },
    colorBurgerNavHover: { key: 'color-burger-nav-hover', value: COLOR_D_A },
    colorBurgerNavSelected: {
      key: 'color-burger-nav-selected',
      value: '#E1AE63'
    },
    colorBurgerNavBorder: { key: 'color-burger-nav-border', value: COLOR_D_A },
    colorBurgerNavBGA: { key: 'color-burger-nav-bg-a', value: COLOR_D_B },
    colorBurgerNavBGB: { key: 'color-burger-nav-bg-b', value: COLOR_F }
  },

  utility: {
    colorUtilitySegmentA: { key: 'color-utility-segment-a', value: '#8A63BE' },
    colorUtilitySegmentB: { key: 'color-utility-segment-b', value: '#9568AD' },
    colorUtilitySegmentEdge: {
      key: 'color-utility-segment-edge',
      value: '#8A63BE'
    },
    colorUtilitySegmentIcon: {
      key: 'color-utility-segment-icon',
      value: '#E0CEF1'
    },
    colorUtilitySegmentAHover: {
      key: 'color-utility-segment-a-hover',
      value: '#1F1F1F'
    },
    colorUtilitySegmentBHover: {
      key: 'color-utility-segment-b-hover',
      value: '#212121'
    },
    colorUtilitySegmentEdgeHover: {
      key: 'color-utility-segment-edge-hover',
      value: '#1B1B1B'
    },
    colorUtilitySegmentIconHover: {
      key: 'color-utility-segment-icon-hover',
      value: '#FFFFFF'
    },
    colorUtilitySegmentASelected: {
      key: 'color-utility-segment-a-selected',
      value: '#AE71C0'
    },
    colorUtilitySegmentBSelected: {
      key: 'color-utility-segment-b-selected',
      value: '#CE9AEC'
    },
    colorUtilitySegmentEdgeSelected: {
      key: 'color-utility-segment-edge-selected',
      value: '#AE71C0'
    },
    colorUtilitySegmentIconSelected: {
      key: 'color-utility-segment-icon-selected',
      value: '#FFFFFF'
    }
  },

  misc: {
    colorBorderHighlight: { key: 'color-border-highlight', value: COLOR_F },
    colorScrollPrompt: { key: 'color-scroll-prompt', value: '#f3e0bb' },
    colorSupTag: { key: 'color-sup-tag', value: '#12100D' },
    colorSupTagBG: { key: 'color-sup-tag-bg', value: '#DADADA' },
    colorSunburst: { key: 'color-sunburst', value: '#FFFFFF' }
  },

  button: {
    colorButtonA: { key: 'color-button-a', value: COLOR_A_A },
    colorButtonAHover: { key: 'color-button-a-hover', value: COLOR_A_A },
    colorButtonAPress: { key: 'color-button-a-press', value: COLOR_A_A },
    colorButtonABG: { key: 'color-button-a-bg', value: '#FFD562' },
    colorButtonABGHover: { key: 'color-button-a-bg-hover', value: '#F6CA39' },
    colorButtonABGPress: { key: 'color-button-a-bg-press', value: COLOR_E },
    colorButtonAGlow: { key: 'color-button-a-glow', value: '#FFF4DD' },
    colorButtonAGlowHover: {
      key: 'color-button-a-glow-hover',
      value: '#FBDF93'
    },
    colorButtonB: { key: 'color-button-b', value: COLOR_A_A },
    colorButtonBHover: { key: 'color-button-b-hover', value: COLOR_A_A },
    colorButtonBPress: { key: 'color-button-b-press', value: COLOR_A_A },
    colorButtonBBG: { key: 'color-button-b-bg', value: '#FFDDA8' },
    colorButtonBBGHover: { key: 'color-button-b-bg-hover', value: COLOR_E_A },
    colorButtonBBGPress: { key: 'color-button-b-bg-press', value: '#FFD470' },
    colorButtonBGlow: { key: 'color-button-b-glow', value: '#FFDC7D' },
    colorButtonBGlowHover: {
      key: 'color-button-b-glow-hover',
      value: COLOR_E_A
    },

    colorButtonC: { key: 'color-button-c', value: COLOR_B_A },
    colorButtonCHover: { key: 'color-button-c-hover', value: COLOR_B_A },
    colorButtonCPress: { key: 'color-button-c-press', value: COLOR_B_A },
    colorButtonCBG: { key: 'color-button-c-bg', value: COLOR_A_A },
    colorButtonCBGHover: { key: 'color-button-c-bg-hover', value: '#4D4D4D' },
    colorButtonCBGPress: { key: 'color-button-c-bg-press', value: '#3C3C3C' },
    colorButtonCGlow: { key: 'color-button-c-glow', value: COLOR_A_A },
    colorButtonCGlowHover: {
      key: 'color-button-c-glow-hover',
      value: COLOR_A_A
    },

    colorButtonD: { key: 'color-button-d', value: COLOR_B_A },
    colorButtonDHover: { key: 'color-button-d-hover', value: COLOR_B_A },
    colorButtonDPress: { key: 'color-button-d-press', value: COLOR_B_A },
    colorButtonDBG: { key: 'color-button-d-bg', value: COLOR_A },
    colorButtonDBGHover: { key: 'color-button-d-bg-hover', value: COLOR_D_A },
    colorButtonDBGPress: { key: 'color-button-d-bg-press', value: COLOR_D_A },
    colorButtonDGlow: { key: 'color-button-d-glow', value: COLOR_A_A },
    colorButtonDGlowHover: {
      key: 'color-button-d-glow-hover',
      value: COLOR_D
    },

    colorButtonE: { key: 'color-button-e', value: COLOR_F },
    colorButtonEHover: { key: 'color-button-e-hover', value: COLOR_F },
    colorButtonEPress: { key: 'color-button-e-press', value: COLOR_F },
    colorButtonEBG: { key: 'color-button-e-bg', value: '#878787' },
    colorButtonEBGHover: { key: 'color-button-e-bg-hover', value: COLOR_A },
    colorButtonEBGPress: { key: 'color-button-e-bg-press', value: '#3C3C3C' },
    colorButtonEGlow: { key: 'color-button-e-glow', value: '#878787' },
    colorButtonEGlowHover: {
      key: 'color-button-e-glow-hover',
      value: COLOR_A
    },

    colorButtonI: { key: 'color-button-i', value: '#202020' },
    colorButtonIHover: { key: 'color-button-i-hover', value: '#202020' },
    colorButtonIPress: { key: 'color-button-i-press', value: '#202020' },
    colorButtonIBG: { key: 'color-button-i-bg', value: '#FFF' }, // Inverted from '#878787'
    colorButtonIBGHover: { key: 'color-button-i-bg-hover', value: COLOR_E_A },
    colorButtonIBGPress: { key: 'color-button-i-bg-press', value: COLOR_E }, // Inverted from '#3C3C3C'
    colorButtonIGlow: { key: 'color-button-i-glow', value: '#FFF' }, // Inverted from '#878787'
    colorButtonIGlowHover: {
      key: 'color-button-i-glow-hover',
      value: COLOR_E
    },

    colorButtonJ: { key: 'color-button-j', value: COLOR_A },
    colorButtonJHover: { key: 'color-button-j-hover', value: COLOR_A },
    colorButtonJPress: { key: 'color-button-j-press', value: COLOR_A },
    colorButtonJBG: { key: 'color-button-j-bg', value: COLOR_A },
    colorButtonJBGHover: { key: 'color-button-j-bg-hover', value: COLOR_A },
    colorButtonJBGPress: { key: 'color-button-j-bg-press', value: COLOR_A },
    colorButtonJGlow: { key: 'color-button-j-glow', value: COLOR_A },
    colorButtonJGlowHover: {
      key: 'color-button-j-glow-hover',
      value: COLOR_A
    },

    colorButtonLight: { key: 'color-button-light', value: '#090909' },
    colorButtonLightHover: {
      key: 'color-button-light-hover',
      value: '#171717'
    },
    colorButtonLightPress: {
      key: 'color-button-light-press',
      value: '#232323'
    },
    colorButtonLightBG: { key: 'color-button-light-bg', value: '#EFEFEF' },
    colorButtonLightBGHover: {
      key: 'color-button-light-bg-hover',
      value: '#fff'
    },
    colorButtonLightBGPress: {
      key: 'color-button-light-bg-press',
      value: '#FFFFFF'
    }, // Inverted from '#3C3C3C'
    colorButtonLightGlow: { key: 'color-button-light-glow', value: '#ececec' },
    colorButtonLightGlowHover: {
      key: 'color-button-light-glow-hover',
      value: '#ececec'
    },

    colorButtonDark: { key: 'color-button-dark', value: '#E6E6E6' },
    colorButtonDarkHover: { key: 'color-button-dark-hover', value: '#E6E6E6' },
    colorButtonDarkPress: { key: 'color-button-dark-press', value: '#E6E6E6' },
    colorButtonDarkBG: { key: 'color-button-dark-bg', value: '#161616' },
    colorButtonDarkBGHover: {
      key: 'color-button-dark-bg-hover',
      value: '#4D4D4D'
    },
    colorButtonDarkBGPress: {
      key: 'color-button-dark-bg-press',
      value: '#3C3C3C'
    },
    colorButtonDarkGlow: { key: 'color-button-dark-glow', value: '#161616' },
    colorButtonDarkGlowHover: {
      key: 'color-button-dark-glow-hover',
      value: '#161616'
    }
  },

  'button-tab': {
    colorButtonTabA: { key: 'color-button-tab-a', value: '#464646' },
    colorButtonTabAHover: { key: 'color-button-tab-a-hover', value: COLOR_B_A },
    colorButtonTabASelected: {
      key: 'color-button-tab-a-selected',
      value: '#fff'
    },
    colorButtonTabABGA: { key: 'color-button-tab-a-bg-a', value: COLOR_D },
    colorButtonTabABGB: { key: 'color-button-tab-a-bg-b', value: COLOR_D_B },
    colorButtonTabABGHoverA: {
      key: 'color-button-tab-a-bg-hover-a',
      value: COLOR_D
    },
    colorButtonTabABGHoverB: {
      key: 'color-button-tab-a-bg-hover-b',
      value: COLOR_D_B
    },
    colorButtonTabABGSelectedA: {
      key: 'color-button-tab-a-bg-selected-a',
      value: COLOR_D
    },
    colorButtonTabABGSelectedB: {
      key: 'color-button-tab-a-bg-selected-b',
      value: COLOR_D_B
    },
    colorButtonTabAStroke: {
      key: 'color-button-tab-a-stroke',
      value: COLOR_DIVIDER_A
    },
    colorButtonTabAStrokeHover: {
      key: 'color-button-tab-a-stroke-hover',
      value: COLOR_DIVIDER_A
    },
    colorButtonTabAStrokeSelected: {
      key: 'color-button-tab-a-stroke-selected',
      value: COLOR_DIVIDER_A
    },

    colorButtonTabB: { key: 'color-button-tab-b', value: COLOR_D_A },
    colorButtonTabBHover: { key: 'color-button-tab-b-hover', value: COLOR_A_A },
    colorButtonTabBSelected: {
      key: 'color-button-tab-b-selected',
      value: COLOR_A_A
    },
    colorButtonTabBBGA: { key: 'color-button-tab-b-bg-a', value: COLOR_E_A },
    colorButtonTabBBGB: { key: 'color-button-tab-b-bg-b', value: COLOR_E },
    colorButtonTabBBGHoverA: {
      key: 'color-button-tab-b-bg-hover-a',
      value: COLOR_E_A
    },
    colorButtonTabBBGHoverB: {
      key: 'color-button-tab-b-bg-hover-b',
      value: COLOR_E
    },
    colorButtonTabBBGSelectedA: {
      key: 'color-button-tab-b-bg-selected-a',
      value: COLOR_E_A
    },
    colorButtonTabBBGSelectedB: {
      key: 'color-button-tab-b-bg-selected-b',
      value: COLOR_E
    },
    colorButtonTabBStroke: {
      key: 'color-button-tab-b-stroke',
      value: COLOR_DIVIDER_A
    },
    colorButtonTabBStrokeHover: {
      key: 'color-button-tab-b-stroke-hover',
      value: COLOR_DIVIDER_A
    },
    colorButtonTabBStrokeSelected: {
      key: 'color-button-tab-b-stroke-selected',
      value: COLOR_DIVIDER_A
    },

    colorButtonTabC: { key: 'color-button-tab-c', value: COLOR_D_A },
    colorButtonTabCHover: { key: 'color-button-tab-c-hover', value: COLOR_B_A },
    colorButtonTabCSelected: {
      key: 'color-button-tab-c-selected',
      value: COLOR_B_A
    },
    colorButtonTabCBGA: { key: 'color-button-tab-c-bg-a', value: COLOR_C_A },
    colorButtonTabCBGB: { key: 'color-button-tab-c-bg-b', value: COLOR_C },
    colorButtonTabCBGHoverA: {
      key: 'color-button-tab-c-bg-hover-a',
      value: COLOR_C_A
    },
    colorButtonTabCBGHoverB: {
      key: 'color-button-tab-c-bg-hover-b',
      value: COLOR_C
    },
    colorButtonTabCBGSelectedA: {
      key: 'color-button-tab-c-bg-selected-a',
      value: COLOR_C_A
    },
    colorButtonTabCBGSelectedB: {
      key: 'color-button-tab-c-bg-selected-b',
      value: COLOR_C
    },
    colorButtonTabCStroke: {
      key: 'color-button-tab-c-stroke',
      value: COLOR_DIVIDER_A
    },
    colorButtonTabCStrokeHover: {
      key: 'color-button-tab-c-stroke-hover',
      value: COLOR_DIVIDER_A
    },
    colorButtonTabCStrokeSelected: {
      key: 'color-button-tab-c-stroke-selected',
      value: COLOR_DIVIDER_A
    }
  },

  'gradient-text': {
    colorGradientTextA: { key: 'color-gradient-text-a', value: '#F7CB8C' },
    colorGradientTextB: { key: 'color-gradient-text-b', value: '#FFB32F' },
    colorGradientTextC: { key: 'color-gradient-text-c', value: '#FFDE9D' },
    colorGradientText2A: { key: 'color-gradient-text-2-a', value: '#A0A0A0' },
    colorGradientText2B: { key: 'color-gradient-text-2-b', value: '#525252' },
    colorGradientText2C: { key: 'color-gradient-text-2-c', value: '#4D4D4D' }
  },

  divider: {
    colorDividerA: { key: 'color-divider-a', value: COLOR_DIVIDER_A },
    colorDividerB: { key: 'color-divider-b', value: COLOR_DIVIDER_A },
    colorDividerC: { key: 'color-divider-c', value: COLOR_DIVIDER_C },
    colorDividerD: { key: 'color-divider-d', value: '#bbb5a9' },
    colorDividerE: { key: 'color-divider-e', value: '#211d18' },
    colorDividerF: { key: 'color-divider-f', value: '#453d34' },
    colorDividerG: { key: 'color-divider-g', value: COLOR_E_A }
  },

  form: {
    colorWarn: { key: 'color-warn', value: '#f46e30' },
    colorOk: { key: 'color-ok', value: '#a5eac3' }
  },

  products: {
    colorProductCardBorder: {
      key: 'color-product-card-border',
      value: COLOR_DIVIDER_A
    },
    colorProductCardBorderHover: {
      key: 'color-product-card-border-hover',
      value: COLOR_DIVIDER_C
    },
    colorProductCardBorderSelected: {
      key: 'color-product-card-border-selected',
      value: '#000'
    },
    colorProductCardBorderDisabled: {
      key: 'color-product-card-border-disabled',
      value: COLOR_DIVIDER_A
    },
    colorProdCardBgA: { key: 'color-product-card-bg-a', value: COLOR_F },
    colorProdCardBgB: { key: 'color-product-card-bg-b', value: COLOR_F },
    colorProdCardBgHoverA: {
      key: 'color-product-card-bg-hover-a',
      value: '#8E8E8E'
    },
    colorProdCardBgHoverB: {
      key: 'color-product-card-bg-hover-b',
      value: '#8E8E8E'
    },
    colorProdCardBgSelectedA: {
      key: 'color-product-card-bg-selected-a',
      value: '#000'
    },
    colorProdCardBgSelectedB: {
      key: 'color-product-card-bg-selected-b',
      value: '#000'
    },
    colorProdCardBgDisabledA: {
      key: 'color-product-card-bg-disabled-a',
      value: COLOR_F
    },
    colorProdCardBgDisabledB: {
      key: 'color-product-card-bg-disabled-b',
      value: COLOR_F
    },
    colorProdCardTitle: { key: 'color-product-card-title', value: '#000' },
    colorProdCardTitleHover: {
      key: 'color-product-card-title-hover',
      value: COLOR_F
    },
    colorProdCardTitleSelected: {
      key: 'color-product-card-title-selected',
      value: COLOR_F
    },
    colorProdCardTitleDisabled: {
      key: 'color-product-card-title-disabled',
      value: '#8B8B8B'
    },
    colorProdCardTitleStroke: {
      key: 'color-product-card-title-stroke',
      value: COLOR_F
    },
    colorProdCardTitleStrokeHover: {
      key: 'color-product-card-title-stroke-hover',
      value: '#8E8E8E'
    },
    colorProdCardTitleStrokeSelected: {
      key: 'color-product-card-title-stroke-selected',
      value: '#000'
    },
    colorProdCardTitleStrokeSelectedHover: {
      key: 'color-product-card-title-stroke-selected-hover',
      value: COLOR_F
    },
    colorProdCardTitleStrokeDisabled: {
      key: 'color-product-card-title-stroke-disabled',
      value: COLOR_F
    },
    colorProdCardFooterIcon: {
      key: 'color-product-card-footer-icon',
      value: '#989898'
    },
    colorProdCardFooterIconHover: {
      key: 'color-product-card-footer-icon-hover',
      value: COLOR_F
    },
    colorProdCardFooterIconSelected: {
      key: 'color-product-card-footer-icon-selected',
      value: COLOR_F
    },
    colorProdCardFooterIconDisabled: {
      key: 'color-product-card-footer-icon-disabled',
      value: COLOR_F
    },
    colorProdCardFooterTest: {
      key: 'color-product-card-footer-text',
      value: '#000'
    },
    colorProdCardFooterTestHover: {
      key: 'color-product-card-footer-text-hover',
      value: COLOR_F
    },
    colorProdCardFooterTestSelected: {
      key: 'color-product-card-footer-text-selected',
      value: COLOR_F
    },
    colorProdCardFooterTestDisabled: {
      key: 'color-product-card-footer-text-disabled',
      value: '#8B8B8B'
    },
    colorProdCardFooter: { key: 'color-product-card-footer', value: '#EEEEEE' },
    colorProdCardFooterHover: {
      key: 'color-product-card-footer-hover',
      value: '#4D4D4D'
    },
    colorProdCardFooterSelectedA: {
      key: 'color-product-card-footer-selected-a',
      value: '#8A8A8A'
    },
    colorProdCardFooterSelectedB: {
      key: 'color-product-card-footer-selected-b',
      value: '#4D4D4D'
    },
    colorProdCardFooterDisabled: {
      key: 'color-product-card-footer-disabled',
      value: '#EEEEEE'
    },
    colorProdCardChevronBG: {
      key: 'color-product-card-chevron-bg',
      value: COLOR_F
    },
    colorProdCardChevronBGHover: {
      key: 'color-product-card-chevron-bg-hover',
      value: COLOR_F
    },
    colorProdCardChevronBGSelected: {
      key: 'color-product-card-chevron-bg-selected',
      value: COLOR_F
    },
    colorProdCardChevronBGDisabled: {
      key: 'color-product-card-chevron-bg-disabled',
      value: COLOR_F
    },
    colorProdCardChevron: {
      key: 'color-product-card-chevron',
      value: COLOR_F
    },
    colorProdCardChevronHover: {
      key: 'color-product-card-chevron-hover',
      value: '#292624'
    },
    colorProdCardChevronSelectedA: {
      key: 'color-product-card-chevron-selected-a',
      value: COLOR_E
    },
    colorProdCardChevronSelectedB: {
      key: 'color-product-card-chevron-selected-b',
      value: COLOR_E_A
    },
    colorProdCardChevronDisabled: {
      key: 'color-product-card-chevron-disabled',
      value: COLOR_F
    },
    colorProdCardGlow: { key: 'color-product-card-glow', value: '#000' },
    colorProdCardGlowHover: {
      key: 'color-product-card-glow-hover',
      value: COLOR_F
    },
    colorProdCardGlowSelected: {
      key: 'color-product-card-glow-selected',
      value: COLOR_F
    },
    colorProdCardGlowDisabled: {
      key: 'color-product-card-glow-disabled',
      value: COLOR_F
    },
    colorProdCardChevronBar: {
      key: 'color-product-card-chevron-bar',
      value: '#8F8F8F'
    },
    colorProdCardNoneBG: {
      key: 'color-product-card-none-bg',
      value: '#979FAA'
    },
    colorProdCardNoneBGHover: {
      key: 'color-product-card-none-bg-hover',
      value: '#7E8691'
    },
    colorProdCardNoneBGSelected: {
      key: 'color-product-card-none-bg-selected',
      value: '#A2A2A2'
    },
    colorProdCardItemShadow: {
      key: 'color-product-card-item-shadow',
      value: '#000'
    },
    colorProdCardItemShadowHover: {
      key: 'color-product-card-item-shadow-hover',
      value: '#000'
    },
    colorProdCardItemShadowSelected: {
      key: 'color-product-card-item-shadow-selected',
      value: '#000'
    },
    colorProdCardDetail: { key: 'color-product-card-detail', value: '#6A6A6A' },
    colorProdCardInfoBGSelected: {
      key: 'color-product-card-info-bg-selected',
      value: '#000'
    },
    colorProdCardThumbnailGlow: {
      key: 'color-product-card-thumbnail-glow',
      value: COLOR_F
    },
    colorProdCardThumbnailBG: {
      key: 'color-product-card-thumbnail-bg',
      value: '#F8F8F8'
    },
    colorProdCardThumbnailBGFocus: {
      key: 'color-product-card-thumbnail-bg-focus',
      value: '#F8F8F8'
    },
    colorProdCardThumbnailBGHover: {
      key: 'color-product-card-thumbnail-bg-hover',
      value: '#F8F8F8'
    },
    colorProdCardThumbnailBGSelected: {
      key: 'color-product-card-thumbnail-bg-selected',
      value: COLOR_F
    },
    colorProdCardThumbnailBGDisabled: {
      key: 'color-product-card-thumbnail-bg-disabled',
      value: '#F8F8F8'
    },
    colorProdCardButtonBG: {
      key: 'color-product-card-button-bg',
      value: '#D5DADE'
    },
    colorProdCardButtonBGHover: {
      key: 'color-product-card-button-bg-hover',
      value: '#B2B2B2'
    },
    colorProdCardButtonBGSelected: {
      key: 'color-product-card-button-bg-selected',
      value: '#7E7E7E'
    },
    colorProdCardButtonBGDisabled: {
      key: 'color-product-card-button-bg-disabled',
      value: '#D5DADE'
    },
    colorProdCardButtonInner: {
      key: 'color-product-card-button-inner',
      value: COLOR_F
    },
    colorProdCardButtonInnerSelected: {
      key: 'color-product-card-button-inner-selected',
      value: COLOR_F
    },
    colorProdCardButtonInnerHover: {
      key: 'color-product-card-button-inner-hover',
      value: COLOR_F
    },
    colorProdCardButtonInnerFocus: {
      key: 'color-product-card-button-inner-focus',
      value: COLOR_F
    },
    colorProdCardButtonInnerDisabled: {
      key: 'color-product-card-button-inner-disabled',
      value: COLOR_F
    },
    colorProdCardSoldOut: {
      key: 'color-product-card-sold-out',
      value: COLOR_A
    },
    colorProdCardSoldOutBG: {
      key: 'color-product-card-sold-out-bg',
      value: '#B9C4C7'
    },
    colorProdCardSoldOutStroke: {
      key: 'color-product-card-sold-out-stroke',
      value: '#778A8A'
    },
    colorProdCardLimitedEdition: {
      key: 'color-product-card-limited-edition',
      value: '#53410F'
    },
    colorProdCardLimitedEditionBG: {
      key: 'color-product-card-limited-edition-bg',
      value: '#FDE28D'
    },
    colorProdCardLimitedEditionStroke: {
      key: 'color-product-card-limited-edition-stroke',
      value: '#D9C771'
    },
    colorProdHeading: { key: 'color-product-heading', value: '#000' }
  },

  'core-color': {
    colorA: { key: 'color-a', value: COLOR_A },
    colorAAccentA: { key: 'color-a-accent-a', value: COLOR_A_A },
    colorAAccentB: { key: 'color-a-accent-b', value: '#0D0D0D' },
    colorB: { key: 'color-b', value: COLOR_B },
    colorBAccentA: { key: 'color-b-accent', value: COLOR_B_A },
    colorC: { key: 'color-c', value: COLOR_C },
    colorCAccentA: { key: 'color-c-accent-a', value: COLOR_C_A },
    colorCAccentB: { key: 'color-c-accent-b', value: COLOR_C_B },
    colorD: { key: 'color-d', value: COLOR_D },
    colorDAccentA: { key: 'color-d-accent-a', value: COLOR_D_A },
    colorDAccentB: { key: 'color-d-accent-b', value: COLOR_D_B },
    colorE: { key: 'color-e', value: COLOR_E },
    colorEAccentA: { key: 'color-e-accent-a', value: COLOR_E_A },
    colorEAccentB: { key: 'color-e-accent-b', value: COLOR_E_B },
    colorF: { key: 'color-f', value: COLOR_F },
    colorFAccent: { key: 'color-f-accent', value: COLOR_F },
    colorG: { key: 'color-g', value: COLOR_F },
    colorGAccent: { key: 'color-g-accent', value: COLOR_F },
    colorH: { key: 'color-h', value: COLOR_F },
    colorHAccentA: { key: 'color-h-accent-a', value: COLOR_F }, // f8f9fe
    colorHAccentB: { key: 'color-h-accent-b', value: COLOR_F },
    colorI: { key: 'color-i', value: '#DDDDDD' },
    colorIAccentA: { key: 'color-i-accent-a', value: '#FFFFFF' },
    colorIAccentB: { key: 'color-i-accent-b', value: '#FFFFFF' },
    colorJ: { key: 'color-j', value: COLOR_A },
    colorJAccentA: { key: 'color-j-accent-a', value: COLOR_A_A },
    colorJAccentB: { key: 'color-j-accent-b', value: '#0D0D0D' },
    colorK: { key: 'color-k', value: COLOR_A_A },
    colorBg: { key: 'color-bg', value: COLOR_F },
    colorBg1: { key: 'color-bg-1', value: COLOR_F },
    colorBg2: { key: 'color-bg-2', value: COLOR_F },
    colorBg3: { key: 'color-bg-3', value: COLOR_F },
    colorBg4: { key: 'color-bg-4', value: COLOR_F },
    colorGoldA: { key: 'color-gold-a', value: '#DBB400' },
    colorGoldB: { key: 'color-gold-b', value: '#BAA31F' },
    colorGoldC: { key: 'color-gold-c', value: '#D3BF48' },
    colorBrightA: { key: 'color-bright-a', value: '#ACB5DA' },
    colorBrightB: { key: 'color-bright-b', value: '#C9B27A' },
    colorBrightC: { key: 'color-bright-c', value: '#C0A2D5' },
    colorCart: { key: 'color-cart', value: '#E04329' }
  }
}

const attributes = {}

export default {
  attributes,
  colors: Object.keys(colors).reduce((res, category) => {
    const group = colors[category]

    Object.keys(group).forEach(colorKey => {
      const color = group[colorKey]

      color.category = category
      res[colorKey] = color
    })

    return res
  }, {})
}
